import { Injectable } from '@angular/core';
import { Transaction } from '../models/transaction';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  private apiUrl = environment.backClient;

  constructor(private http: HttpClient) {}

  // 🔁 Récupère le token à jour à chaque appel
  private get token(): string | null {
    return localStorage.getItem('token');
  }

  // 🔐 Centralise les headers
  private get headers(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json',
      }),
    };
  }

  // 👥 Récupérer tous les employés
  getTransactions(client: string, sub: any): Observable<Transaction[]> {
    return this.http.get<Transaction[]>(
      `${this.apiUrl}/${client}/transactions/${sub}`,
      this.headers
    );
  }
}
